const TheModule = () => import("./TheModule.vue");
const TheUser = () => import("./views/TheUser.vue");
const TheSettings = () => import("./views/TheSettings.vue");

const moduleRoute = {
  path: "/account",
  component: TheModule,
  redirect: 'account/data',
  meta: {
    requiresAuthenticated: true
  },
  children: [
    {
      path: "data",
      component: TheUser,
      meta: {
        requiresAuthenticated: true
      }
    },
    {
      path: "settings",
      component: TheSettings,
      meta: {
        requiresAuthenticated: true
      }
    },

  ]
};

export default router => {
  router.addRoutes([moduleRoute]);
};
